import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const SubscriptionCard = superstyled({
  tag: Box,
  name: 'RestartConfirmStep',
  slot: 'SubscriptionCard',
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: theme.shape.rounded['2xl'],
    boxShadow: theme.shadows[1],
    overflow: 'hidden',
    paddingBlock: theme.spacing(1.5),
  }),
});

export const SubscriptionCardDivider = superstyled({
  tag: Divider,
  name: 'RestartConfirmStep',
  slot: 'SubscriptionCardDivider',
  styles: {
    marginInline: 0,
  },
});

export const ChangePaymentButton = superstyled({
  tag: Button,
  name: 'RestartConfirmStep',
  slot: 'ChangePaymentButton',
  styles: ({ theme }) => ({
    color: theme.palette.primary.main,
    minWidth: 0,
    padding: 0,
  }),
});

export const SubmitButtonRow = superstyled({
  tag: Stack,
  name: 'RestartConfirmStep',
  slot: 'SubmitButtonRow',
  styles: ({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
      '& > *': { width: '100%' },
    },
  }),
});

export const SubmitButton = superstyled({
  tag: Button,
  name: 'RestartConfirmStep',
  slot: 'SubmitButton',
  styles: {
    borderRadius: '12px',
    height: 56,
  },
});
